import React from 'react'
import { useSelector } from 'react-redux'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap'
import { selectService29Enabled } from '../../../redux/slices'
import { Link } from 'react-router-dom'
// import './DevicesMenu.css'

const DevicesMenu = (props) => {
  const service29Enabled = useSelector(selectService29Enabled)

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className="glyphicons glyphicons-hdd">
        <p className="nav-link-p">{props.label}</p>
      </DropdownToggle>
      <DropdownMenu className="submenu">
        <DropdownItem>
          <a href="/ui/#!/devices" className="glyphicons glyphicons-hdd">
            Overview
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/versions"
            className="glyphicons glyphicons-info-sign"
          >
            Component Versions
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/downloadFiles/create/"
            className="glyphicons glyphicons-inbox-out"
          >
            Send to Device
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/downloadFiles"
            className="glyphicons glyphicons-calendar"
          >
            Update History
          </a>
        </DropdownItem>
        <DropdownItem>
          <Link to='/ui2/devices/fleetManager' className='glyphicons glyphicons-database-search'>
            Fleet Manager
          </Link>
        </DropdownItem>
        {service29Enabled && (
          <DropdownItem>
            <Link
              to="/ui2/service29"
              className="glyphicons glyphicons-certificate"
            >
              Service 29 Certificate Management
            </Link>
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default DevicesMenu
